module.exports = "https://web-assets.ifttt.com/packs/media/social-signon/google_on_color-d2a19004.svg";